var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_22510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C11.8406 10.5 14.1429 8.26133 14.1429 5.5C14.1429 2.73867 11.8406 0.5 9 0.5C6.15938 0.5 3.85714 2.73867 3.85714 5.5C3.85714 8.26133 6.15938 10.5 9 10.5ZM9 1.75C11.1271 1.75 12.8571 3.43203 12.8571 5.5C12.8571 7.56758 11.1271 9.25 9 9.25C6.87295 9.25 5.14286 7.56641 5.14286 5.5C5.14286 3.43203 6.87455 1.75 9 1.75ZM11.0371 12.375H6.96295C3.11826 12.375 0 15.4062 0 19.1445C0 19.8922 0.623571 20.4988 1.39259 20.4988H16.6082C17.3772 20.5 18 19.8945 18 19.1445C18 15.4062 14.8821 12.375 11.0371 12.375ZM16.6058 19.25H1.39259C1.33393 19.25 1.28571 19.2031 1.28571 19.1445C1.28571 16.1016 3.83304 13.625 6.96295 13.625H11.033C14.167 13.625 16.7143 16.1016 16.7143 19.1445C16.7143 19.2031 16.6661 19.25 16.6058 19.25Z",
    fill: "#7575A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_22510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.88035f0f7d7a387c7aef8e32b3e7392c.svg";
export { ForwardRef as ReactComponent };